/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, memo } from "react";
import ProgramCampaign from "./Components/ProgramCampaign";
import ProgramMerchandising from "./Components/ProgramMerchandising";
import ProgramLoyalty from "./Components/ProgramLoyalty";
import NoneData from "components/NoneData";

import {
	getListCampaignAction,
	getLoyaltyDetailAction,
	setMerchandisingDetailAction,
	setLoyaltyDetailAction,
	setMenuPromotionAction
} from "store/actions/SpecialOfferPageAction";
import { HEIGHT_HEADER } from "config/constant";
import { Grid } from "@material-ui/core";
import { setSpecialOfferDetailAction } from "store/actions/ProgramDetailAction";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

const SpecialOfferPage = memo(props => {
	const {
		listCampaign,
		listLoyalty,
		listMerchandising,
		infoShop,
		loyaltyDetail,
		dispatchGetListCampaign,
		dispatchGetLoyaltyDetail,
		dispatchSetSpecialOfferDetail,
		dispatchSetMerchandisingDetail,
		dispatchSetLoyaltyDetail,
		dispatchSetMenuPromotion
	} = props;

	const history = useHistory();
	const business = infoShop?.business || "THOPHAT";

	const idNotification = new URLSearchParams(history.location.search).get(
		"id"
	);
	const typeNotification = new URLSearchParams(history.location.search).get(
		"type"
	);

	useEffect(() => {
		dispatchGetListCampaign(business);
		dispatchSetMenuPromotion(0);
		return () => {
			dispatchSetMerchandisingDetail({});
			dispatchSetLoyaltyDetail({});
		};
	}, []);

	useEffect(() => {
		if (!!idNotification && typeNotification === "GIFT") {
			const data = {
				business: business,
				loyaltyId: idNotification
			};
			dispatchGetLoyaltyDetail(data);
		}
	}, [idNotification, typeNotification]);

	const handleClickProgramCampaign = id => {
		history.push(`/promotion_detail?id=${id}`);
	};

	const handleClickProgramMerchandising = id => {
		history.push(`/merchandising_detail?id=${id}`);
	};

	const handleClickProgramLoyalty = id => {
		const data = {
			business: business,
			loyaltyId: id
		};
		dispatchGetLoyaltyDetail(data);
	};

	return listCampaign?.length > 0 ||
		listMerchandising?.length > 0 ||
		listLoyalty?.length > 0 ? (
		<Grid
			style={{
				height: `calc(100vh - ${HEIGHT_HEADER}px)`,
				overflowY: "scroll"
			}}
		>
			{listCampaign?.length > 0 && (
				<ProgramCampaign
					listCampaign={listCampaign}
					handleClickProgramCampaign={handleClickProgramCampaign}
				/>
			)}
			{listMerchandising?.length > 0 && (
				<ProgramMerchandising
					listMerchandising={listMerchandising}
					handleClickProgramMerchandising={
						handleClickProgramMerchandising
					}
				/>
			)}
			{listLoyalty?.length > 0 && (
				<ProgramLoyalty
					listLoyalty={listLoyalty}
					loyaltyDetail={loyaltyDetail}
					handleClickProgramLoyalty={handleClickProgramLoyalty}
					setSpecialOfferDetail={dispatchSetSpecialOfferDetail}
					business={business}
				/>
			)}
		</Grid>
	) : (
		<NoneData />
	);
});

const mapStateToProps = state => {
	return {
		listCampaign: state.specialOfferPageReducer.listCampaign,
		listLoyalty: state.specialOfferPageReducer.listLoyalty,
		listMerchandising: state.specialOfferPageReducer.listMerchandising,
		loyaltyDetail: state.specialOfferPageReducer.loyaltyDetail,
		infoShop: state.homePageReducer.infoShop
	};
};

const mapDispatchToProps = dispatch => {
	return {
		dispatchGetListCampaign: data => {
			dispatch(getListCampaignAction(data));
		},
		dispatchGetLoyaltyDetail: data => {
			dispatch(getLoyaltyDetailAction(data));
		},
		dispatchSetSpecialOfferDetail: data => {
			dispatch(setSpecialOfferDetailAction(data));
		},
		dispatchSetMerchandisingDetail: data => {
			dispatch(setMerchandisingDetailAction(data));
		},
		dispatchSetLoyaltyDetail: data => {
			dispatch(setLoyaltyDetailAction(data));
		},
		dispatchSetMenuPromotion: params => {
			dispatch(setMenuPromotionAction(params));
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SpecialOfferPage);
